import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import DOMPurify from 'dompurify';

import 'Container/AnnuaireCorrespondant/AnnuaireCorrespondants.scss';
import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import { rechercheAnnuaireCorrespondants } from "../../api/correspondantsService";
import { checkFields, renderError, upperCaseRemoveAccent } from "../../utils/formUtils";
import PaginationWithTable from "../../Components/PaginationWithTable/PaginationWithTable";
import { useSelector } from "react-redux";

export default function AnnuaireCorresponsants() {

    const {
        referencesApp,
        referencesAppLastUpdated,
        loadingReferencesApp,
    } = useSelector(state => ({
        ...state.resourcesReducer,
    }))

    console.log("referencesApp")
    console.log(referencesApp)

    const CONF = window?.confPub;
    const UI = CONF?.UI?.ANNUAIRE_CORRESPONDANTS;
    const INPUTS = UI?.INPUTS;

    const [submitted, setSubmitted] = useState(false);
    const [disabledPage, setDisabledPage] = useState(false);
    const [isDepartement, setIsDepartement] = useState(true);

    const initForm = () => {
        return {
            departement: {
                value: '',
                invalid: false,
            },
            codePostal: {
                value: '',
                invalid: false,
            },
            nom: {
                value: '',
                invalid: false,
            },
            prenom: {
                value: '',
                invalid: false,
            },
        }
    }

    const [form, setForm] = useState(initForm());
    const [noResultFound, setNoResultFound] = useState("Pas de résultats pour cette recherche.");
    const [annuaire, setAnnuaire] = useState([]);

    const handleRadio = (e) => {

        setSubmitted(false);
        const radioValue = e.target.value;

        setIsDepartement(radioValue === INPUTS?.FORM_RADIO?.OPTIONS?.DEPARTEMENT?.VALUE)
    }

    const handleInput = (e) => {

        const { name, value, type } = e?.target

        const valueUpdated = type === 'text' ? upperCaseRemoveAccent(value) : value

        const { invalid } = checkFields(name, valueUpdated, false);


        const newForm = {
            ...form,
            [name]: {
                value: valueUpdated,
                invalid: invalid,
            }
        };

        setForm(newForm);
    }

    const submitForm = async (e) => {

        e.preventDefault();
        setSubmitted(true);
        setDisabledPage(true);

        const inputs = Array.from(e.target);

        let newForm = {
            ...form,
        };

        inputs.forEach(({name, value}) => {

            if (name && name !== "radioDepartementCodePostal") {

                const isMandatory = !(name === INPUTS?.NOM?.NAME || name === INPUTS?.PRENOM?.NAME)

                const { invalid } = checkFields(name, value, isMandatory);

                newForm = {
                    ...newForm,
                    [name]: {
                        value: value,
                        invalid: invalid,
                    }
                }
            }
        });

        setForm(newForm);

        let invalidForm = true

        if ((!isDepartement && !newForm?.codePostal?.invalid && newForm?.codePostal?.value)
            || (isDepartement && !newForm?.departement?.invalid && newForm?.departement?.value)
            || (newForm?.nom?.value && !newForm?.nom?.invalid)
            || (newForm?.prenom?.value && !newForm?.prenom?.invalid)) {

            invalidForm = false
        }

        if (!invalidForm) {

            const departementCodePostal = (isDepartement && !newForm?.departement?.invalid) ? newForm?.departement?.value :
                (!isDepartement && !newForm?.codePostal?.invalid) ? newForm?.codePostal?.value : ""
            const nomPreapred = newForm?.nom?.invalid ? "" : newForm?.nom?.value?.trim()
            const prenomPreapred = newForm?.prenom?.invalid ? "" : newForm?.prenom?.value?.trim()

            try {

                const correspondantsReturn = await rechercheAnnuaireCorrespondants(departementCodePostal?.trim(), nomPreapred, prenomPreapred)

                console.log("correspondantsReturn")
                console.log(correspondantsReturn)

                if (Array.isArray(correspondantsReturn)) {

                    setAnnuaire(correspondantsReturn)

                } else {

                    setAnnuaire([])
                }

            } catch (err) {

                console.log('err: ', err);
                setAnnuaire([]);

            } finally {

                setDisabledPage(false);
                setNoResultFound("Pas de résultats pour cette recherche.");
            }

        } else {

            setDisabledPage(false);
            setAnnuaire([]);
            setNoResultFound("Au moins un des paramètres doit être renseigné.");
        }
    }

    const effacerRecherche = () => {

        setForm(initForm());
        setSubmitted(false);
        setAnnuaire([]);
    }

    const BuildCorrespondantsTable = ({ data: displayAnnuaire }) => {

        return (
            <div className='table-responsive-lg'>

                <table className="table">
                    <thead>
                    <tr>
                        <th>Établissement</th>
                        <th>Correspondant</th>
                        <th>Adresse</th>
                        <th>Coordonnées</th>
                    </tr>
                    </thead>

                    <tbody>
                    { displayAnnuaire?.length > 0 && displayAnnuaire?.map(correspondant => (
                        // eslint-disable-next-line react/jsx-key
                        <tr key={ uuidv4() }>
                            <td>{ correspondant?.raisonSociale }</td>
                            <td>
                                <div>{ correspondant?.nom } { correspondant?.prenom }</div>
                                <div>{ correspondant?.typeFonction }</div>
                            </td>
                            <td>
                                <div>{ correspondant?.ligAdresse1 }</div>
                                <div>{ correspondant?.codePostal } { correspondant?.ville }</div>
                            </td>
                            <td>
                                <div><span className='bold'>Téléphone :</span> { correspondant?.numTel }</div>
                                { correspondant?.numFax &&
                                    <div><span className='bold'>Fax :</span> { correspondant?.numFax }</div> }
                                <div><span className='bold'>Email :</span> { correspondant?.courriel }</div>
                            </td>
                        </tr>
                    )) }
                    </tbody>
                </table>
            </div>
        )
    }

    return (
        <div className='container mt-3'>

            <main id='content' className='overlay-container'>

                { disabledPage && <LoadingOverlay classes="upload-overlay"/> }

                <div className="card">
                    <div className="card-header">
                        <h1 className="my-2">Annuaire des correspondants</h1>
                    </div>

                    <div className="card-body">
                        <form onSubmit={ submitForm }>
                            <fieldset>

                                <div className='row'>
                                    <div className='col mb-3'>
                                        <span>Recherche par : </span>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name={ INPUTS?.FORM_RADIO.NAME }
                                                id={ INPUTS?.FORM_RADIO?.OPTIONS?.DEPARTEMENT?.ID }
                                                checked={ isDepartement }
                                                onChange={ handleRadio }
                                                value={ INPUTS?.FORM_RADIO?.OPTIONS?.DEPARTEMENT?.VALUE }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={ INPUTS?.FORM_RADIO?.OPTIONS?.DEPARTEMENT?.ID }>
                                                { INPUTS?.FORM_RADIO?.OPTIONS?.DEPARTEMENT?.LABEL }
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name={ INPUTS?.FORM_RADIO.NAME }
                                                id={ INPUTS?.FORM_RADIO?.OPTIONS?.CODE_POSTAL?.ID }
                                                checked={ !isDepartement }
                                                onChange={ handleRadio }
                                                value={ INPUTS?.FORM_RADIO?.OPTIONS?.CODE_POSTAL?.VALUE }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={ INPUTS?.FORM_RADIO?.OPTIONS?.CODE_POSTAL?.ID }>
                                                { INPUTS?.FORM_RADIO?.OPTIONS?.CODE_POSTAL?.LABEL }
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 col-lg-4 mb-3">

                                                { isDepartement ? (
                                                    <>
                                                        <label
                                                            htmlFor={ UI?.INPUTS?.DEPARTEMENT?.NAME }
                                                            className='form-label '
                                                            dangerouslySetInnerHTML={ {
                                                                __html: DOMPurify.sanitize(UI?.INPUTS?.DEPARTEMENT?.LABEL)
                                                            } }/>
                                                        <select
                                                            name={ INPUTS?.DEPARTEMENT?.NAME }
                                                            className="form-select"
                                                            onChange={ handleInput }
                                                            value={ form?.departement?.value }
                                                            aria-label="Default select example">
                                                            <option
                                                                key={ "" }
                                                                value={ "" }
                                                            >
                                                                { "Tous les département" }
                                                            </option>
                                                            { !loadingReferencesApp && referencesApp?.departements?.map(option => (
                                                                <option
                                                                    key={ option?.code }
                                                                    value={ option?.code }
                                                                >
                                                                    { option?.libelle }
                                                                </option>
                                                            )) }
                                                        </select>
                                                        { submitted && isDepartement && form?.departement?.invalid && renderError(form?.departement?.invalid) }
                                                    </>
                                                ) : (
                                                    <>
                                                        <label
                                                            htmlFor={ UI?.INPUTS?.CODE_POSTAL?.NAME }
                                                            className='form-label'
                                                            dangerouslySetInnerHTML={ {
                                                                __html: DOMPurify.sanitize(UI?.INPUTS?.CODE_POSTAL?.LABEL)
                                                            } }/>
                                                        <input
                                                            name={ UI?.INPUTS?.CODE_POSTAL?.NAME }
                                                            className={ `form-control ${ submitted }` }
                                                            onChange={ handleInput }
                                                            value={ form?.codePostal?.value }
                                                            placeholder={ UI?.INPUTS?.CODE_POSTAL?.PLACEHOLDER }
                                                            type="text"/>

                                                        { submitted && !isDepartement && !form?.nom?.value && !form?.prenom?.value
                                                            && form?.codePostal?.invalid && renderError(form?.codePostal?.invalid) }
                                                    </>
                                                ) }
                                            </div>

                                            <div className='col-12 col-lg-4 mb-3'>
                                                <label
                                                    htmlFor={ UI?.INPUTS?.NOM?.NAME }
                                                    className='form-label'
                                                    dangerouslySetInnerHTML={ {
                                                        __html: DOMPurify.sanitize(UI?.INPUTS?.NOM?.LABEL)
                                                    } }/>

                                                <input
                                                    name={ UI?.INPUTS?.NOM?.NAME }
                                                    className={ `form-control ${ submitted }` }
                                                    onChange={ handleInput }
                                                    value={ form?.nom?.value }
                                                    placeholder={ UI?.INPUTS?.NOM?.PLACEHOLDER }
                                                    type="text"/>

                                                { submitted && form?.nom?.invalid && renderError(form?.nom?.invalid) }
                                            </div>

                                            <div className='col-12 col-lg-4 mb-3'>
                                                <label
                                                    htmlFor={ UI?.INPUTS?.PRENOM?.NAME }
                                                    className='form-label'
                                                    dangerouslySetInnerHTML={ {
                                                        __html: DOMPurify.sanitize(UI?.INPUTS?.PRENOM?.LABEL)
                                                    } }/>

                                                <input
                                                    name={ UI?.INPUTS?.PRENOM?.NAME }
                                                    className={ `form-control ${ submitted }` }
                                                    onChange={ handleInput }
                                                    value={ form?.prenom?.value }
                                                    placeholder={ UI?.INPUTS?.PRENOM?.PLACEHOLDER }
                                                    type="text"/>

                                                { submitted && form?.prenom?.invalid && renderError(form?.prenom?.invalid) }
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-lg-3 d-flex align-items-end mt-3">
                                                <button type='submit' className="btn btn-primary">
                                                    Recherche
                                                </button>
                                                <button type='button' className="btn btn-secondary ms-2"
                                                        onClick={ effacerRecherche }>
                                                    Effacer
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>

                    <section id='resultats' className='mt-3 mx-2'>

                        { annuaire?.length === 0 && submitted && (
                            <div className='d-flex justify-content-center'>
                                <p>{ noResultFound }</p>
                            </div>
                        ) }

                        { annuaire?.length > 0 && (

                            <PaginationWithTable
                                records={ annuaire }
                                recordsPerPage={ 6 }
                                TableComponent={ BuildCorrespondantsTable }
                            />
                        )}
                    </section>

                </div>
            </main>
        </div>
    )
}